import curry from "./curry";

const get = curry((prop, obj) => {
    if (typeof obj !== 'object') {
        return undefined;
    }

    const p = Array.isArray(prop) ? prop : [prop];
    return p.reduce((currObj, currProp) => (currObj && currObj[currProp]) ? currObj[currProp] : undefined, obj);
});

export default get;
